import React from 'react';
import './FeatureWidget.css';

const ChoiseWidget = ({ image, title, description }) => {
    return (
        <div className="choice-widget-container" >
            <h2 className="choice-widget-title">{title}</h2>
            <br></br>
            <div className={'center choiceImage'}><img id={'choiseImage'} src={image} alt="" width={'50%'}/></div>
            <p className="choice-widget-content darkerText" style={{}}>{description}</p>
        </div>
    );
};

export default ChoiseWidget;